export const SET_WARING_INFO = "SET_WARING_INFO";
export const SET_CURENT_GARDEN = "SET_CURENT_GARDEN";